
export const GET_COMMON_CODE_GROUP_KEYWORD_LIST = 'GET_COMMON_CODE_GROUP_KEYWORD_LIST';
export const GET_COMMON_CODE_GROUP_KEYWORD_LIST_SUCCESS = 'GET_COMMON_CODE_GROUP_KEYWORD_LIST_SUCCESS';
export const GET_COMMON_CODE_DTL_LIST_GROUP = 'GET_COMMON_CODE_DTL_LIST_GROUP';
export const GET_COMMON_CODE_DTL_LIST_GROUP_SUCCESS = 'GET_COMMON_CODE_DTL_LIST_GROUP_SUCCESS';
export const GET_COMMON_CODE_DTL_LIST_GROUP_CLEAR = 'GET_COMMON_CODE_DTL_LIST_GROUP_CLEAR';
export const SET_COMMON_CODE_GROUP = 'SET_COMMON_CODE_GROUP';
export const GET_COMMON_CODE_GROUP = 'GET_COMMON_CODE_GROUP';
export const GET_COMMON_CODE_GROUP_SUCCESS = 'GET_COMMON_CODE_GROUP_SUCCESS';
export const SET_COMMON_CODE_DTL = 'SET_COMMON_CODE_DTL';
export const GET_COMMON_CODE_GROUP_LIST = 'GET_COMMON_CODE_GROUP_LIST';
export const GET_COMMON_CODE_GROUP_LIST_SUCCESS = 'GET_COMMON_CODE_GROUP_LIST_SUCCESS';

export const getCommonCodeGroupKeywordList = payload => {
    return { type: GET_COMMON_CODE_GROUP_KEYWORD_LIST, payload };
};
export const getCommonCodeGroupKeywordListSuccess = payload => {
    return { type: GET_COMMON_CODE_GROUP_KEYWORD_LIST_SUCCESS, payload };
};
export const getCommonCodeDtlListGroup = payload => {
    return { type: GET_COMMON_CODE_DTL_LIST_GROUP, payload };
};
export const getCommonCodeDtlListGroupSuccess = payload => {
    return { type: GET_COMMON_CODE_DTL_LIST_GROUP_SUCCESS, payload };
};
export const getCommonCodeDtlListGroupClear = payload => {
    return { type: GET_COMMON_CODE_DTL_LIST_GROUP_CLEAR, payload };
};
export const setCommonCodeGroup = payload => {
    return { type: SET_COMMON_CODE_GROUP, payload };
};
export const getCommonCodeGroup = payload => {
    return { type: GET_COMMON_CODE_GROUP, payload };
};
export const getCommonCodeGroupSuccess = payload => {
    return { type: GET_COMMON_CODE_GROUP_SUCCESS, payload };
};
export const setCommonCodeDtl = payload => {
    return { type: SET_COMMON_CODE_DTL, payload };
};
export const getCommonCodeGroupList = payload => {
    return { type: GET_COMMON_CODE_GROUP_LIST, payload };
};
export const getCommonCodeGroupListSucess = payload => {
    return { type: GET_COMMON_CODE_GROUP_LIST_SUCCESS, payload };
};